
    /* eslint-disable */

    import Vue, { Component } from "vue";
    import { OccasionService } from "@/services/OccasionService";
    import Occasion, { OccasionDisplay } from "@/models/api/occasion/Occasion";
    import OccasionCreate from "@/models/api/occasion/OccasionCreate";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { DataTableHelper } from '@/helpers/DataTableHelper';
    import { AxiosError } from "axios";
    import { ActivityService } from "@/services/ActivityService";
    import { SnackbarService } from "@/services/SnackbarService";
    import { UserService } from "@/services/UserService";
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import { ValidationHelper } from '@/helpers/ValidationHelper';
    import { Frequencies, OccasionTypes } from '../../models/Enums';   
    import AssociationActivity from "@/models/api/association/AssociationActivity";
    import Activity from "@/models/api/activity/Activity";
    import AddParticipantDialog from "@/components/dialogs/AddParticipantDialog.vue";
    import SelectListItem from '../../models/SelectListItem';
    import ParticipantGroupRegistrationRequest from '../../models/api/participant-group/ParticipantGroupRegisterRequest';
    import { PersonService } from '@/services/PersonService';
    import Person from "../../models/api/person/Person";
    import { SettingService } from '../../services/SettingService';
    import ApplicationSettingDto from '../../models/api/ApplicationSetting';
    import { ApplicationSetting, Gender } from '../../models/Enums';
    import adaptSSN from '../../helpers/functions/AdaptSSN';
    import adaptZipCode from '../../helpers/functions/AdaptZipCode';
    import { validateSSNDate, validateDateOfBirth, validateSSN } from '../../helpers/functions/ValidateSSN';
    import validateSSNSetting from '../../helpers/functions/ValidateSSNSetting';

    export default Vue.extend({
        components: {
            DeleteDialog,
            AddParticipantDialog
        },
        data() {
            return {
                pageHeader: this.$vuetify.lang.t('$vuetify.occasion.pageHeader'),

                ongoingSaves: -1,

                totalCountComing: 0,
                itemsComing: [],
                isTableLoadingComing: true,
                optionsComing: {},

                totalCountConfirmed: 0,
                itemsConfirmed: [],
                isTableLoadingConfirmed: true,
                optionsConfirmed: {},

                tableHeaders: [
                    {
                        text: 'date',
                        sortable: true,
                        value: 'date',
                    },
                    {
                        text: 'time',
                        sortable: true,
                        value: 'time'
                    },
                    {
                        text: 'occasion.location',
                        sortable: true,
                        value: 'location',
                    },
                    {
                        text: 'group.groupName',
                        sortable: true,
                        value: 'groupName',
                    },
                    {
                        text: 'activity.activityName',
                        sortable: true,
                        value: 'activityName',
                    },
                    {
                        text: '',
                        sortable: false,
                        value: 'actions'
                    },
                ],

                tableHeadersConfirmed: [
                    {
                        text: 'date',
                        sortable: true,
                        value: 'date',
                    },
                    {
                        text: 'time',
                        sortable: true,
                        value: 'time'
                    },
                    {
                        text: 'occasion.location',
                        sortable: true,
                        value: 'location',
                    },
                    {
                        text: 'group.groupName',
                        sortable: true,
                        value: 'groupName',
                    },
                    {
                        text: 'activity.activityName',
                        sortable: true,
                        value: 'activityName',
                    },
                    {
                        text: 'occasion.participants',
                        sortable: true,
                        value: 'numberOfParticipants',
                    },
                    {
                        text: '',
                        sortable: false,
                        value: 'actions'
                    },
                ],

                optionsUnconfirmed: {},
                totalCountUnconfirmed: 0,
                itemsUnconfirmed: [],
                isTableLoadingUnconfirmed: true,              

                tableHeadersConfirm: [
                    {
                        text: 'name',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: '',
                        sortable: false,
                        align: 'center',
                        width: '1%',
                        class: 'slimDataTableColumnPaddingRight',
                        cellClass: 'slimDataTableColumnPaddingRight',
                        value: 'edit'
                    },
                    {
                        text: '',
                        sortable: false,
                        align: 'center',
                        width: '1%',
                        class: 'slimDataTableColumnPaddingRight',
                        cellClass: 'slimDataTableColumnPaddingRight',
                        value: 'remove'
                    },
                    {
                        text: 'occasion.temporaryLeaderShort',
                        sortable: false,
                        align: 'center',
                        width: '1%',
                        value: 'tempLeader',
                    },
                    {
                        text: 'occasion.isPresent',
                        sortable: false,
                        align: 'center',
                        width: '1%',
                        value: 'actions'
                    },
                ],
                itemsConfirm: {} as any,
                isTableLoadingConfirm: false,
                occasionConfirm: {} as Occasion,
                allParticipantsSelected: false,
                allLeadersSelected: false,
                allPersonsHasMandatoryData: false,

                occasionsTab: null,

                createDialogOpen: false,
                editDialogOpen: false,
                confirmDialogOpen: false,
                dialogKey: 0,
                editPersonDialogOpen: false,

                registrationRequest: new OccasionCreate(),
                recurring: false,

                // Create
                showTimeFromCreate: false,
                showTimeToCreate: false,
                showDateFromCreate: false,
                showDateToCreate: false,

                showDateEdit: false,
                showTimeFromEdit: false,
                showTimeToEdit: false,

                registerOccasionFormValid: false,

                editOccasionRequest: {} as Occasion,
                editOccasionRecurringOccasions: [] as SelectListItem[],

                showDeleteRecurringDialog: false,

                // Delete dialog
                showDeleteDialog: false,
                itemToDeleteId: "",
                itemToDeleteName: "",

                // Add participant dialog
                addParticipantDialogOpen: false,
                                      
                selectedFrequency: "",

                frequencies: [] as SelectListItem[],
                occasionTypes: [] as SelectListItem[],

                groups: [] as SelectListItem[],
                activities: [] as AssociationActivity[],

                locations: [] as string[],
                searchLocation: null as string | null,

                personRequest: {} as Person,
                persons: new Array<Person>(),

                settings: new Array<ApplicationSettingDto>(),
                isActivitySSNMandatory: false,                
                formatDateOfBirth: "",
                showZipCode: false,
                showCity: false,
                genders: [{ text: this.$vuetify.lang.t('$vuetify.female'), value: 1 }, { text: this.$vuetify.lang.t('$vuetify.male'), value: 2 }],
                genderId: null as Gender | null,
                registerPersonFormValid: false,
                selectedOccasionGroupId: 0,

                rules: {
                    required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),
                    zipCode: (value: any) => !value || /^\d{3}\s*\d{2}$/.test(value) || this.$vuetify.lang.t('$vuetify.invalidZipCode'),
                    ssnFormat: (value: any) => !value || /^\d{4}\d{2}\d{2}-\d{4}$/.test(value) || this.$vuetify.lang.t('$vuetify.formatSSN'),
                    validateSSNDate: (value: any) => validateSSNDate(value) || this.$vuetify.lang.t('$vuetify.person.invalidDate'),
                },

            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.tableHeadersConfirm, this);
            DataTableHelper.adaptTableHeaders(this.tableHeadersConfirmed, this);
            DataTableHelper.adaptTableHeaders(this.tableHeaders, this);
            //this.getOccasions();

            this.getSettingsByKeyName();          

            this.frequencies = [];
            Object.values(Frequencies).map((n: string | Frequencies) => {
                if (typeof Frequencies[n as any] === 'number') {
                    this.frequencies.push(new SelectListItem(this.$vuetify.lang.t('$vuetify.occasion.' + Frequencies[Frequencies[n as number] as any]), Frequencies[n as any]));
                }
            });
            this.occasionTypes = [];
            Object.values(OccasionTypes).map((n: string | OccasionTypes) => {
                if (typeof OccasionTypes[n as any] === 'number') {
                    this.occasionTypes.push(new SelectListItem(this.$vuetify.lang.t('$vuetify.occasion.' + OccasionTypes[OccasionTypes[n as number] as any]), OccasionTypes[n as any]));
                }
            });

            this.$store.commit('addOverlay');
            UserService.GetGroups().then(response => {
                this.groups = response.data;
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });

            this.$store.commit('addOverlay');
            ActivityService.GetAssociationActivities().then(response => {
                this.activities = response.data;
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });



        },
        watch: {
            recurring: {
                handler() {
                    if (this.recurring && this.registrationRequest.frequency == null) {
                        this.registrationRequest.frequency = Frequencies.EveryWeek;
                    } else if (!this.recurring) {
                        this.registrationRequest.frequency = null;
                    }
                }
            },
            searchLocation: {
                handler() {
                    if (this.searchLocation && this.searchLocation.length > 2) {
                        OccasionService.GetLocations(this.searchLocation as string).then(response => {
                            this.locations = response.data;
                        });
                    } else {
                        this.locations = [];
                    }
                }
            },
            optionsComing: {
                handler() {
                    this.getOccasionsComing();
                },
                deep: true,
            },
            optionsConfirmed: {
                handler() {
                    this.getOccasionsConfirmed();
                },
                deep: true,
            },
            optionsUnconfirmed: {
                handler() {
                    this.getOccasionsUnconfirmed();
                },
                deep: true,
            },
            createDialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.createForm as VuetifyFormMethods).reset();
                    }
                },
            },
            editDialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
            editPersonDialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.personForm as VuetifyFormMethods).reset();
                    } else {
                        this.$nextTick(() => {
                            (this.$refs.personForm as VuetifyFormMethods).validate();
                        });
                    }
                },
            },

        },
        computed: {
            sumLeaders() {
                return (item: any) => {
                    if (this.itemsConfirm && this.itemsConfirm.leaders) {
                        const sum = this.itemsConfirm.leaders.filter((s: any) => s.isPresent).length;
                        return sum;
                    }
                    return 0;
                };
            },
            sumParticipants() {
                return (item: any) => {
                    if (this.itemsConfirm && this.itemsConfirm.leaders) {
                        const sum = this.itemsConfirm.participants.filter((s: any) => s.isPresent).length;
                        return sum;
                    }
                    return 0;
                };
            },
        },
        methods: {
            getValidationRules(): any[] {
                setTimeout(() => (this.$refs.personForm as VuetifyFormMethods)?.validate());
                if (this.isActivitySSNMandatory && !this.personRequest.hasNoSwedishSsn) {
                    return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.rules.ssnFormat];
                }
                return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.validDateOfBirth];
            },
            validateSSNSettings(v: any): boolean | string {
                return validateSSNSetting(v, this.isActivitySSNMandatory && !this.personRequest.hasNoSwedishSsn, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.invalidSSN');
            },
            fixSSN() {
                this.personRequest.socialSecurityNumber = adaptSSN(this.personRequest.socialSecurityNumber);
            },
            fixZipCode() {
                this.personRequest.zipCode = adaptZipCode(this.personRequest.zipCode);
            },
            increaseOngoingSaves(): void {
                if (this.ongoingSaves < 0) {
                    this.ongoingSaves = 0;
                }
                this.ongoingSaves++;
            },
            decreaseOngoingSaves(): void {
                this.ongoingSaves--;
            },
            resetOngoingSaves(): void {
                this.ongoingSaves = -1;
            },
            timeToEditRule: function (): any {
                if (this.editOccasionRequest.timeFrom < this.editOccasionRequest.timeTo) {
                    return true;
                } else {
                    return this.$vuetify.lang.t('$vuetify.timeTo') + ' ' + this.$vuetify.lang.t('$vuetify.mustBeAfter') + ' ' + this.$vuetify.lang.t('$vuetify.timeFrom') ;
                }
            },
            timeToCreateRule: function (): any {
                if (this.registrationRequest.timeFrom < this.registrationRequest.timeTo) {
                    return true;
                } else {
                    return this.$vuetify.lang.t('$vuetify.timeTo') + ' ' + this.$vuetify.lang.t('$vuetify.mustBeAfter') + ' ' + this.$vuetify.lang.t('$vuetify.timeFrom');
                }
            },
            dateToCreateRule: function (): any {
                if (this.registrationRequest.dateFrom == null || this.registrationRequest.dateTo == null || this.registrationRequest.dateFrom < this.registrationRequest.dateTo) {
                    return true;
                } else {
                    return this.$vuetify.lang.t('$vuetify.dateTo') + ' ' + this.$vuetify.lang.t('$vuetify.mustBeAfter') + ' ' + this.$vuetify.lang.t('$vuetify.dateFrom');
                }
            },
            prepareDeleteDialog(item: OccasionDisplay) {
                this.showDeleteDialog = true;
                this.itemToDeleteId = item.id + '';
                this.itemToDeleteName = item.dayOfWeekText + ' ' + item.dateText + ' ' + item.timeFrom + ' - ' + item.timeTo;
            },
            prepareDeleteFollowingDialog(item: OccasionDisplay) {
                if (item.isRecurring) {
                    this.showDeleteRecurringDialog = true;
                    this.itemToDeleteId = item.id + '';
                    this.itemToDeleteName = item.dayOfWeekText + ' ' + item.dateText + ' ' + item.timeFrom + ' - ' + item.timeTo;
                } else {
                    this.prepareDeleteDialog(item);
                }
            },
            removeParticipant(participant: any) {
                const data = {
                    occasionId: this.occasionConfirm.id,
                    occasionParticipantId: participant.id
                };

                this.increaseOngoingSaves();

                this.$store.commit('addOverlay');
                OccasionService.RemoveParticipant(data).then(() => {
                    this.prepareOccasionConfirm(this.occasionConfirm);
                })
                .catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                    this.resetOngoingSaves();
                })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                    this.decreaseOngoingSaves();
                });
            },
            addParticipant(participant: ParticipantGroupRegistrationRequest, addPersonToGroup: boolean) {
                //console.log("adding participant", participant, addPersonToGroup);
                participant.groupId = addPersonToGroup ? this.selectedOccasionGroupId : 0;
                this.increaseOngoingSaves();
                const data = { participant: participant, occasionId: this.occasionConfirm.id, addPersonToGroup: addPersonToGroup, groupId: this.selectedOccasionGroupId };
                this.$store.commit('addOverlay');
                OccasionService.AddParticipant(data)
                    .then(() => {
                        this.addParticipantDialogOpen = false;
                        this.prepareOccasionConfirm(this.occasionConfirm);
                    })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                        this.resetOngoingSaves();
                    })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                        this.decreaseOngoingSaves();
                    });
            },          
            updateAllParticipantsSelected() {
                let result = false;
                if (this.itemsConfirm && this.itemsConfirm.participants) {
                    result = !this.itemsConfirm.participants.some((s: any) => !s.isPresent );
                }
                this.allParticipantsSelected = result;
            },
            selectAllParticipants(): void {
                if (this.itemsConfirm && this.itemsConfirm.participants) {
                    if (this.allParticipantsSelected) {
                        this.itemsConfirm.participants.forEach((s: any) => {
                            if (!s.isPresent) {
                                s.isPresent = true;
                                this.saveIsPresent(s);
                            }
                        });
                    } else {
                        this.itemsConfirm.participants.forEach((s: any) => {
                            if (s.isPresent) {
                                s.isPresent = false;
                                this.saveIsPresent(s);
                            }
                        });
                    }
                }
            },
            updateAllLeadersSelected() {
                let result = false;
                if (this.itemsConfirm && this.itemsConfirm.participants) {
                    result = !this.itemsConfirm.leaders.some((s: any) => !s.isPresent);
                }
                this.allLeadersSelected = result;
            },
            selectAllLeaders(): void {
                if (this.itemsConfirm && this.itemsConfirm.participants) {
                    if (this.allLeadersSelected) {
                        this.itemsConfirm.leaders.forEach((s: any) => { s.isPresent = true; this.saveIsPresent(s); });
                    } else {
                        this.itemsConfirm.leaders.forEach((s: any) => { s.isPresent = false; this.saveIsPresent(s); });
                    }
                }
            },

            getEditGroupName(): string {
                if (this.editOccasionRequest && this.editOccasionRequest.groupId) {
                    const index = this.getGroupIndex(this.editOccasionRequest.groupId);
                    if (index >= 0) {
                        return this.groups[index].text;
                    }
                }

                return "";
            },
            getGroupIndex(groupId: number) {
                if (!groupId) {
                    return -1;
                }
                return this.groups.findIndex((s: SelectListItem) => s.value == groupId.toString());
            },
            closeEdit() {
                this.editDialogOpen = false;
                this.editOccasionRequest = {} as Occasion;
            },
            closeCreate() {
                this.createDialogOpen = false;
                this.registrationRequest = new OccasionCreate();
            },
            closeConfirm() {
                this.confirmDialogOpen = false;
                this.ongoingSaves = -1;
                this.getOccasionsUnconfirmed();
                this.getOccasionsComing();
                this.getOccasionsConfirmed();
                //Counter for v-dialog. Resets the scrolling position after close
                this.dialogKey++;
            },
            closePersonEdit() {                
                this.editPersonDialogOpen = false;
                this.personRequest = {} as Person;               
            },
            saveParticipantsConfirmed(): void {
                const data = { occasionId: this.occasionConfirm.id, isParticipantsConfirmed: this.itemsConfirm.isParticipantsConfirmed };

                this.increaseOngoingSaves();
                OccasionService.SetParticipantsConfirmed(data)
                    .then(result => {
                        if (!this.itemsConfirm.isParticipantsConfirmed) {
                            this.itemsConfirm.participantsConfirmed = "";
                            this.itemsConfirm.participantsConfirmedBy = "";
                            //Reload participants when occasion unconfirmed
                            this.getParticipants(data.occasionId);
                        }
                    })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                        this.itemsConfirm.isParticipantsConfirmed = !this.itemsConfirm.isParticipantsConfirmed;
                        this.resetOngoingSaves();
                    })
                    .finally(() => {
                        this.decreaseOngoingSaves();
                    });
            },
            getParticipants(id: number) {
                OccasionService.GetParticipants(id).then(response => {
                    this.itemsConfirm = response.data;
                    this.selectedOccasionGroupId = this.itemsConfirm.groupId;
                    this.updateAllParticipantsSelected();
                    this.updateAllLeadersSelected();
                    this.allPersonsHasMandatoryData = !this.itemsConfirm.participants.some((s: any) => !s.hasMandatoryData) && !this.itemsConfirm.leaders.some((s: any) => !s.hasMandatoryData);
                    this.isActivitySSNMandatory = this.itemsConfirm.isActivitySSNMandatory; //we get mandatory flag from activity not application setting as we do in the personal register
                })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                    });
            },
            prepareOccasionConfirm(item: Occasion): void {
                this.$store.commit('addOverlay');
                OccasionService.GetParticipants(item.id).then(response => {
                    this.itemsConfirm = response.data;
                    this.confirmDialogOpen = true;
                    this.selectedOccasionGroupId = this.itemsConfirm.groupId;
                    this.occasionConfirm = item;
                    this.updateAllParticipantsSelected();
                    this.updateAllLeadersSelected();
                    this.allPersonsHasMandatoryData = !this.itemsConfirm.participants.some((s: any) => !s.hasMandatoryData) && !this.itemsConfirm.leaders.some((s: any) => !s.hasMandatoryData);
                    this.isActivitySSNMandatory = this.itemsConfirm.isActivitySSNMandatory; //we get mandatory flag from activity not application setting as we do in the personal register
                })
                .catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });
            },
            saveIsTemporaryLeader(item: any): void {
                const data = { personId: item.personId, occasionId: item.occasionId, isTemporaryLeader: item.isTemporaryLeader };

                this.increaseOngoingSaves();

                this.$store.commit('addOverlay');
                OccasionService.SetIsTemporaryLeader(data)
                    .then(result => {
                        this.prepareOccasionConfirm(this.occasionConfirm);
                    })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );

                        item.isTemporaryLeader = !item.isTemporaryLeader;
                        this.resetOngoingSaves();
                    })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                        this.decreaseOngoingSaves();
                    });
            },
            saveIsPresent(item: any): void {
                const data = { personId: item.personId, occasionId: item.occasionId, isPresent: item.isPresent };

                this.increaseOngoingSaves();

                OccasionService.SetIsPresent(data)
                .then(result => {})
                .catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                    item.isPresent = !item.isPresent;
                    this.resetOngoingSaves();
                })
                .finally(() => {
                    this.decreaseOngoingSaves();
                    this.updateAllParticipantsSelected();
                    this.updateAllLeadersSelected();
                });
                this.updateAllParticipantsSelected();
                this.updateAllLeadersSelected();
            },
            prepareOccasionEdit(item: Occasion): void {
                this.$store.commit('addOverlay');
                OccasionService.GetOccasion(item.id)
                    .then(response => {
                        this.editOccasionRequest = response.data;
                        this.editDialogOpen = true;
                        if (this.editOccasionRequest.isRecurring) {
                            OccasionService.GetRecurringOccasions(this.editOccasionRequest.id).then(responseOcc => {
                                this.editOccasionRecurringOccasions = responseOcc.data;
                            })
                            .catch((error) => {
                                SnackbarService.addErrorMessage(
                                    error.response?.data || error.response?.statusText
                                );
                            })
                            .finally(() => {
                                this.$store.commit('removeOverlay');
                            });
                        }
                    })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                    });
            },
            async createOccasion() {
                // If there is only one group in groups we use that group for the occasion
                if (this.groups.length == 1) {
                    this.registrationRequest.groupId = typeof this.groups[0].value !== 'number' ? parseInt(this.groups[0].value) : this.groups[0].value as number;
                }

                (this.$refs.locationCreateCombobox as HTMLElement).blur();

                this.$nextTick(() => {
                    if (!(this.$refs.createForm as VuetifyFormMethods).validate()) {
                        return;
                    }

                    this.$store.commit('addOverlay');

                    OccasionService.CreateOccasion(this.registrationRequest).then(
                        (result) => {
                            this.getOccasionsUnconfirmed();
                            this.getOccasionsComing();
                            this.getOccasionsConfirmed();
                            this.closeCreate();

                            SnackbarService.addSuccessMessage(result?.data);

                        })
                        .catch((error) => {
                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        })
                        .finally(() => {
                            this.$store.commit('removeOverlay');
                        });
                });
            },
            async removeOccasion(id: number) {
                this.showDeleteDialog = false;
                this.showDeleteRecurringDialog = false;

                if (id != null) {
                    this.$store.commit('addOverlay');
                    OccasionService.RemoveOccasion(id).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);

                            this.getOccasionsUnconfirmed();
                            this.getOccasionsComing();
                            this.getOccasionsConfirmed();
                        },
                        (error: AxiosError) => {
                            console.log(error);

                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    ).finally(() => {
                        this.$store.commit('removeOverlay');
                    });
                }
            },
            async removeOccasionAndFollowing(id: string) {
                this.showDeleteDialog = false;
                this.showDeleteRecurringDialog = false;

                if (id != null) {
                    this.$store.commit('addOverlay');
                    OccasionService.RemoveOccasionAndFollowing(parseInt(id)).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);

                            this.getOccasionsUnconfirmed();
                            this.getOccasionsComing();
                            this.getOccasionsConfirmed();
                        },
                        (error: AxiosError) => {
                            console.log(error);

                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    ).finally(() => {
                        this.$store.commit('removeOverlay');
                    });
                }
            },
            saveOccasion() {
                (this.$refs.locationEditCombobox as HTMLElement).blur();

                this.$nextTick(() => {
                    if (!(this.$refs.editForm as VuetifyFormMethods).validate()) {
                        return;
                    }
                    this.$store.commit('addOverlay');
                    OccasionService.SaveOccasion(this.editOccasionRequest as Occasion).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);
                            this.getOccasionsUnconfirmed();
                            this.getOccasionsComing();
                            this.getOccasionsConfirmed();
                            this.closeEdit();
                        },
                        (error: AxiosError) => {
                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    ).finally(() => {
                        this.$store.commit('removeOverlay');
                    });
                });
            },
            async getOccasionsComing() {
                const sortBy = (this.optionsComing as any).sortBy ?? [];
                const sortDesc = (this.optionsComing as any).sortDesc ?? [];
                const page = (this.optionsComing as any).page ?? 1;
                const itemsPerPage = (this.optionsComing as any).itemsPerPage ?? 10;

                const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage, showPassed: false };

                this.isTableLoadingComing = true;
                OccasionService.GetOccasionsPaged(data).then(response => {
                    this.itemsComing = response.data.items;
                    this.totalCountComing = response.data.totalCount;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                .finally(() => {
                    this.isTableLoadingComing = false;
                });
            },
            async getOccasionsConfirmed() {
                const sortBy = (this.optionsConfirmed as any).sortBy ?? [];
                const sortDesc = (this.optionsConfirmed as any).sortDesc ?? [];
                const page = (this.optionsConfirmed as any).page ?? 1;
                const itemsPerPage = (this.optionsConfirmed as any).itemsPerPage ?? 10;

                const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage };

                this.isTableLoadingConfirmed = true;
                OccasionService.GetConfirmedPaged(data).then(response => {
                    this.itemsConfirmed = response.data.items;
                    this.totalCountConfirmed = response.data.totalCount;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                    .finally(() => {
                        this.isTableLoadingConfirmed = false;
                    });
            },
            async getOccasionsUnconfirmed() {
                const sortBy = (this.optionsUnconfirmed as any).sortBy ?? [];
                const sortDesc = (this.optionsUnconfirmed as any).sortDesc ?? [];
                const page = (this.optionsUnconfirmed as any).page ?? 1;
                const itemsPerPage = (this.optionsUnconfirmed as any).itemsPerPage ?? 10;

                const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage };

                this.isTableLoadingUnconfirmed = true;
                OccasionService.GetUnconfirmedPaged(data).then(response => {
                    this.itemsUnconfirmed = response.data.items;
                    console.log("Items unconfirmed", this.itemsUnconfirmed);
                    this.totalCountUnconfirmed = response.data.totalCount;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                    .finally(() => {
                        this.isTableLoadingUnconfirmed = false;
                    });

            },
            getApplicationSetting(app: ApplicationSetting) {
                return this.settings.findIndex((val: any) => val.keyName == app);
            },

            async getSettingsByKeyName() {

                SettingService.GetSettingsByKeyNames("FormatOfDateOfBirth, ZipCodeVisibleAndMandatory,CityVisibleAndMandatory")
                    .then(response => {
                        this.settings = response.data;

                        this.formatDateOfBirth = this.settings[this.getApplicationSetting(ApplicationSetting.FormatOfDateOfBirth)].value.toString();
                        this.showZipCode = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.ZipCodeVisibleAndMandatory)].value.toString().toLowerCase());
                        this.showCity = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.CityVisibleAndMandatory)].value.toString().toLowerCase());

                        
                    }).catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }).finally(() => {
                        /*this.loading = false;*/
                        this.$store.commit('removeOverlay');
                    });

            },
            editPerson(person: any) {
                // Keeps row in datatable the same, whilst updating the values.
                this.$store.commit('addOverlay');
                PersonService.GetPerson(person.personId).then(response => {
                    this.personRequest = response.data;
                    this.editPersonDialogOpen = true;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                    });

            },
            async savePerson(itemToUpdate: Person) {

                if (!(this.$refs.personForm as VuetifyFormMethods).validate()) {
                    return;
                }

                if (itemToUpdate.id != null && itemToUpdate.id > 0) {
                    PersonService.EditPerson(itemToUpdate, "").then((result) => {
                    //   SnackbarService.addSuccessMessage(result?.data, false);
                       
                        this.prepareOccasionConfirm(this.occasionConfirm);
                        this.closePersonEdit();
                    },
                        (error: AxiosError) => {

                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    );
                }
            },
            // rules
            validDateOfBirth(value: string): string | boolean {
                return validateDateOfBirth(value, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.person.invalidDate');
            },
            // rules

            /* Not to be used before getPersons() is fixed to not fetch all persons full info and called on created!!!
            async getPersons() {
                this.persons = (await PersonService.GetPersons()).data;
            },
            uniqueSocialSecurityNumber(value: string): string | boolean {
                // Filter except from the item being edited.

                if (
                    value &&
                    this.persons
                        .filter((x) => x.id != this.personRequest.id)
                        .findIndex(
                            (f) =>
                                f.socialSecurityNumber.trim().toLocaleLowerCase() ==
                                value.trim().toLocaleLowerCase()
                        ) > -1
                ) {
                    return false;
                    //return this.$vuetify.lang.t('$vuetify.person.SSNAlreadyExists') + " " + value;
                }

                return true;
            },*/

            checkValidSSN(value: string): string | boolean {
                return validateSSN(value) || this.$vuetify.lang.t('$vuetify.invalidSSN');
            },
        },
    });
